<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="here px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">最終確認</h3>
    <p class="exp">
      以下の内容でよろしければ入会申込みを確定するを押してください。
    </p>

    <div class="form-order-confirm border box-p-20 my-5">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center">
          <p>商品</p>
        </div>
        <div class="shohin_quantity text-center">
          <p>個数</p>
        </div>
        <div class="shohin_price text-center">
          <p>価格</p>
        </div>
      </div>
      <div id="CartList">
        <ul>
          <ConfirmItem
            v-for="item in cart.goods"
            :key="item.no"
            :btotal="true"
            :item="item"
          ></ConfirmItem>
          <ConfirmItem
            v-for="item in cart.tools"
            :key="item.no"
            :btotal="true"
            :item="item"
          ></ConfirmItem>
          <ConfirmItem
            v-for="item in cart.camps"
            :key="item.no"
            :btotal="true"
            :item="item"
          ></ConfirmItem>
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>小計</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.ItemAmount }}円</p>
        </div>
      </div>
      <div class="style-d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>代金引換手数料</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.CollectFee }}円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>送料</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.CarriageFee }}円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>合計</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.Total }}円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>付与予定ポイント</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ point }}ポイント</p>
        </div>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/shopping-in0001/order/confirm' }"
          class="btn d-inline-block"
        >
          カートに戻る
        </router-link>
      </div>
    </div>
    <div class="form-member border box-p-20 mb-5">
      <h3 class="mb-5 teext-left">お届け先、お届け日、お支払方法</h3>
      <div id="divDeliveryConfirm" class="inner">
        <dl style="margin-bottom: 0; border-bottom: 0">
          <dt>お受取りについて</dt>
          <dd>本人が受取ることを同意する</dd>
          <dt>お届け先</dt>
          <dd>{{ delivery.ToDelivery }}</dd>
        </dl>
        <dl
          v-if="delivery.ToDelivery == 'ご自宅以外'"
          style="margin-bottom: 0; border-bottom: 0"
        >
          <dt style="width: 100%; float: none; background: #fff">
            ※ご自宅以外のお届け先
          </dt>
          <dt>郵便番号</dt>
          <dd>{{ delivery.ZipCode2 }}</dd>
          <dt>住所</dt>
          <dd>{{ delivery.Part1OfAddress }}</dd>
          <dt>住所<span class="fs-08">（フリガナ）</span></dt>
          <dd>{{ delivery.AddressKana }}</dd>
          <dt>住所<span class="fs-08">（建物名）</span></dt>
          <dd>{{ delivery.Part2OfAddress }}</dd>
          <dt>宛先</dt>
          <dd>{{ delivery.Part3OfAddress }}</dd>
          <dt>電話番号</dt>
          <dd>{{ delivery.TelNo }}</dd>
        </dl>
        <dl>
          <dt>お届け指定日</dt>
          <dd>{{ delivery.DeliveryDate }}</dd>
          <dt>お届け時間帯</dt>
          <dd>{{ delivery.DeliveryTime }}</dd>
          <dt>お支払方法</dt>
          <dd>{{ delivery.PaymentMethod }}</dd>
        </dl>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/shopping-in0001/delivery' }"
          class="btn d-inline-block"
        >
          お届け、お支払方法を変更する
        </router-link>
      </div>
    </div>
    <div class="form-member border box-p-20 mb-5">
      <div class="inner">
        <h3 class="mb-5 teext-left">申込者情報</h3>
        <dl id="divRegistrationConfirm">
          <!-- 動的生成部 -->
          <form>
            <dl id="dlConfirm">
              <dt>氏名</dt>
              <dd>{{ registration.Name1 }}&emsp;{{ registration.Name2 }}</dd>
              <dt>氏名<span class="fs-08">（フリガナ）</span></dt>
              <dd>
                {{ registration.NameKana1 }}&emsp;{{ registration.NameKana2 }}
              </dd>
              <dt>性別</dt>
              <dd>{{ registration.Sex }}</dd>
              <dt>配偶者</dt>
              <dd>{{ registration.Spouse }}</dd>
              <dt>生年月日</dt>
              <dd>{{ registration.BirthDay }}</dd>
              <dt>郵便番号</dt>
              <dd>{{ registration.ZipCode }}</dd>
              <dt>住所</dt>
              <dd>{{ registration.Part1OfAddress }}</dd>
              <dt>住所<span class="fs-08">（フリガナ）</span></dt>
              <dd>{{ registration.AddressKana }}</dd>
              <dt>住所<span class="fs-08">（建物名）</span></dt>
              <dd>{{ registration.Part2OfAddress }}</dd>
              <dt>住所<span class="fs-08">（その他）</span></dt>
              <dd>{{ registration.Part3OfAddress }}</dd>
              <dt>配送時連絡先</dt>
              <dd>{{ registration.UseTelKind }}</dd>
              <dt v-if="registration.UseTelKind == '携帯電話番号'">
                携帯電話番号
              </dt>
              <dd v-if="registration.UseTelKind == '携帯電話番号'">
                {{ registration.TelM }}
              </dd>
              <dt v-if="registration.UseTelKind == '自宅電話番号'">
                自宅電話番号
              </dt>
              <dd v-if="registration.UseTelKind == '自宅電話番号'">
                {{ registration.TelK }}
              </dd>
              <dt>FAX番号</dt>
              <dd>{{ registration.TelF }}</dd>
              <!-- <dt>紹介者の氏名</dt>
              <dd>
                {{ registration.SpoName1 }}&emsp;{{ registration.SpoName2 }}
              </dd>
              <dt>紹介者の氏名<span class="fs-08">（フリガナ）</span></dt>
              <dd>
                {{ registration.SpoNameKana1 }}&emsp;{{
                  registration.SpoNameKana2
                }}
              </dd>
              <dt>紹介者の会員番号</dt>
              <dd>{{ registration.SpoNumber }}</dd>
              <dt>紹介者の電話番号</dt>
              <dd>{{ registration.SpoTelNumber }}</dd> -->
              <dt>パスワード</dt>
              <dd>{{ registration.PassWord }}</dd>
              <dt>当社からの広告等のメール・FAX送信</dt>
              <dd>{{ registration.WantMail }}</dd>
            </dl>
          </form>
        </dl>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/shopping-in0001/registration' }"
          class="btn d-inline-block"
        >
          申込者情報の登録へ戻る
        </router-link>
      </div>
    </div>
    <div v-show="paymentMethod != 3" class="box-p-20 text-center mb-5">
      <button
        v-on:click="putData"
        id="btnSend"
        type="button"
        class="confirm-01 clear"
      >
        入会申込みを確定する
      </button>
    </div>
    <div v-show="paymentMethod == 3">
      <div class="box-p-20 text-center mb-5">
        <button
          type="submit"
          @click="creditSubmit"
          class="btn d-inline-block my-5"
        >
          クレジットカード情報入力
        </button>
      </div>
      <form :action="creditUrl" method="post">
          <input type="hidden" name="pay_id" v-model="shopId" />
          <input type="hidden" name="pay_pass" v-model="apiKey" />
          <!-- 顧客ID-->
          <input type="hidden" name="cust_code" v-model="custCode" />
          <!-- 注文番号 -->
          <input type="hidden" name="order_id" v-model="orderNo"/>
          <!-- 氏名-->
          <input type="hidden" name="cust_name" v-model="custName" />
          <!-- 電話番号 -->
          <input type="hidden" name="cust_tell" v-model="tel" id="TelNo" />
          <!-- メールアドレス -->
          <input type="hidden" name="cust_email" v-model="mail" id="MailAddress" />

          <!-- 商品番号 -->
          <input type="hidden" name="item_id" value="0001" />
          <!-- 商品名 -->
          <input type="hidden" name="item_name" value="マナビス化粧品購入商品" />
          <!-- 金額 -->
          <input type="hidden" name="amount" v-model="creditTotal">
          <!-- 消費税-->
          <input type="hidden" name="tax" value="0" />
          <!-- サイトID-->
          <input type="hidden" name="site_id" v-model="siteId" />
          <!-- 支払い種別 -->
          <input type="hidden" name="pay_type" value="1" />
          <!-- 支払い種別 -->
          <input type="hidden" name="pay_method" value="0" />
          <!-- UID -->
          <input type="hidden" name="param1" v-model="uux"/>
          <input type="hidden" name="api_url" v-model="returnURL1">
          <input type="hidden" name="succ_url" v-model="returnURL2">
        </form>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import ConfirmItem from "./components/ConfirmItem";
import Message from "@/modules/Message";
import Device from "@/modules/Device";
let device = new Device();
export default {
  components: {
    ConfirmItem,
  },
  mounted() {
    this.getData();
    // クレジット決済用パラメータの決定
    this.pType = device.isMobile() ? 5 : 3;
    window.scroll(0, 0);
  },
  data() {
    return {
      cart: [],
      delivery: [],
      registration: [],
      point: "0",
      paymentMethod: 0,
      // クレジット決済に利用する
      pType: "",
      orderNo: "",
      tel: "",
      mail: "",
      uux: "",
      creditUrl: process.env.VUE_APP_CREDIT_URL,
      shopId: "SPSSFA0000056997",
      apiKey: "cM7ssV!03Xg",
      siteId: "0001",
      custCode: "",
      custName:"",
      //api用URL
      returnURL1:process.env.VUE_APP_CREDIT_RETURN_URL3,
      //画面遷移用
      returnURL2:process.env.VUE_APP_CREDIT_RETURN_URL4,
      creditTotal:"",

      // test用のパラメータ
      tmpCreditTest: process.env.NODE_ENV == "test",
      creditTest: process.env.NODE_ENV == "development",
      creditResult: 1,
      pid: new Date().getTime(),
      WillbeCollectedPoint: 0,
      usePoint: 0,
      total: 0,
      isProxy: false,
      creditSubTotal: 0,
      creditSubTotal2: 0,
      payPoint: false,
      carriageFee: 0,
    };
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDelivery",
        [false],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data)
          this.cart = data.CartConfirm;
          this.delivery = data.DeliveryConfirm;
          this.registration = data.RegistrationConfirm;
          if (this.delivery.PaymentMethod == "クレジットカード") {
            this.paymentMethod = 3;
          } else {
            this.paymentMethod = 0;
          }
          if(this.registration.UseTelKind == '携帯電話番号'){
            this.tel = this.registration.TelM.replace("-", "")
            this.tel = this.tel.replace("-", "")
          }else if(this.registration.UseTelKind == '自宅電話番号'){
            this.tel = this.registration.TelK.replace("-", "")
            this.tel = this.tel.replace("-", "")
          }
          console.log('mail:'+this.Mail)
          this.mail = data.Mail;
          this.point = data.Point;
          this.custCode = data.No;
          this.custName = this.registration.Name1+' '+this.registration.Name2;
          this.creditTotal = this.cart.Total.replace(",", "");
          this.creditSubTotal2 = this.cart.ItemAmount.replace(",","");
          this.carriageFee = this.cart.CarriageFee.replace(",","");
        });
    },
    putData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putNewJoin",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push({
            path: "/shopping-in0001/delivery/end",
          });
        });
    },
    creditSubmit() {
      Message.confirm()
        .fire({
          title: "カード会社のサイトへ移動します。よろしいですか？",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let requestParams = request.createParams(
              "webMdlNewJoin",
              "putNewJoin",
              [],
              true
            );
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                this.uux = data.Uux;
                this.orderNo = data.OrderNumber;
                this.$nextTick(() => {
                  document.forms[1].submit();
                });
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.cart_set dl {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cart_set dt {
  width: 300px;
  padding: 10px 15px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  background: #fafafa;
}
.cart_set dd {
  padding: 10px 15px;
  width: calc(100% - 300px);
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .cart_set dt,
  .cart_set dd {
    width: 100%;
  }
}
</style>